export const API_PRX = {
  PHOTO: '/photo',
} as const;
